import Wow from 'wow.js';

jQuery(document).ready(() => {
  const wow = new Wow();
  wow.init();
});



// WEBPACK FOOTER //
// ./scripts/autoload/_wow.js